import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editTab: true,
  hasEditPdc: null,
  editTabData: null,
  hasEditData: null,
  accounts_supplier_code: '',
  supplierAccountsFormValid: false,
  isError: {
    accounts_supplier_code: true
  }
}

const supplierAccounts = createSlice({
  name: 'supplier_accounts',
  initialState,
  reducers: {
    brandSearch: (state, action) => {
      const { parent, key, value } = action.payload;
      state[parent][key] = value;
    },
    supplierAccountsInput: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
      state[key].length === 0 ? state.isError[key] = true : state.isError[key] = false
    },
    getIsError: (state, action) => {
      const { key, value } = action.payload;
      state.isError[key] = value
    },
    setAutocomplete: (state, action) => {
      const { parent, key, value } =  action.payload;
      state[parent][key] = value
    },
    hasTabEdit: (state, action) => {
      const { editTab } =  action.payload;
      state.editTab = editTab
    },
    hasTabEditData: (state, action) => {
      const { editData } =  action.payload;
      state.editTabData = editData
    },
    setHasEditData: (state, action) => {
      state.hasEditData = action.payload;
    },
    setSupplierAccountsFormStatus: (state, action) => {
      state.supplierAccountsFormValid = action.payload;
    },
    resetSupplierAccounts: () => {
      return initialState
    },
  }
})

export const { brandSearch, hasTabEditData, setAutocomplete, getIsError, supplierAccountsInput, hasTabEdit, resetSupplierAccounts, setHasEditData, setSupplierAccountsFormStatus } = supplierAccounts.actions

export default supplierAccounts.reducer